import React, { useContext, useEffect, useState } from "react";
import Migas from "../migasGeomedellin/Migas";
import { Container, Tab, Tabs, Row, Col } from "react-bootstrap";
import PiePagina from "../piePagina/PiePagina";
import contextGeomedellin from "../../../context/contextGeomedellin";
import { UploadFileIcon } from "../../common/UploadFileIcon";
import { MdOutlineModeEdit } from "react-icons/md";
import { TableReporteEstadistica } from "../../common/TableReporteEstadistica";
import { utils, writeFileXLSX } from "xlsx";
import { useNavigate } from "react-router-dom";

// custom hooks
import { usePermisions } from "../../../hooks/usePermisions";
// variables globales
import { URL_IMAGE_GEOMEDELLIN } from "../../../environment";
import { Combo } from "../combos/Combo";
import { DatePickerGeo } from "../../common/DatePickerGeo";
import { Pagination } from "../../common/Pagination";
import getDatos from "../../../services/getDatos";
import Load from "../../common/Load";
import guardarUbicacion from "../../../services/guardarUbicacion";
import Tableros from "./Tableros";
import EstadisticasDatosAbiertos from "./EstadisticasDatosAbiertos";
import consultarInfoToken from "../../../services/consultarInfoToken";

const initialStateFiltros = {
  dateRange: [null, null],
  tipo: "-1",
  estado: "",
  page: 1,
  rowPerPage: 15,
};

const initialStateDataReporte = {
  data: [],
  meta: { total: 0 },
};

export default function Estadisticas({
  idComponente,
  caractFiltro,
  descripcion,
  imagen,
}) {
  const navigate = useNavigate();

  //contexto global geomdellin, donde se almacenan los estados globales de la aplicación
  const { restablecerEstilos } = useContext(contextGeomedellin);
  const [currentPage, setCurrentPage] = useState(1);
  const [load, setLoad] = useState(true);

  const [dataReporte, setDataReporte] = useState(initialStateDataReporte);

  const [dataReporteXlsx, setDataReporteXlsx] = useState(null);

  const [combosFiltros, setCombosFiltros] = useState({
    resultFuenteDato: [],
    resultOrigen: [],
    resultTipo: [],
    resultTipoRecurso: [],
    resultTipoEstado: [],
    resultTipoTablero: [],
  });

  const [filtrosReportes, setFiltrosReportes] = useState(initialStateFiltros);

  useEffect(() => {
    guardarUbicacion("6", "2", "0");
  }, []);

  const listarCombosReporte = async () => {
    try {
      const response = await getDatos("atributos/combosestadistica/openData");
      setCombosFiltros(response);
      listarEstadisticas();
    } catch (err) {
      return false;
    }
  };

  const onChangeFiltros = (target, type) => {
    if (type === "date") {
      setFiltrosReportes((prev) => {
        return { ...prev, dateRange: target };
      });

      return;
    }

    if (type === "combo" || type === "radio") {
      const { value, name } = target;

      return setFiltrosReportes((prev) => {
        return { ...prev, [name]: value };
      });
    }
  };

  const limpiarFiltros = () => {
    setFiltrosReportes(initialStateFiltros);
    setCurrentPage(1);
    // setDataReporte(initialStateDateReporte);
    listarEstadisticas(1, true);
  };

  const { permissions } = usePermisions(idComponente);

  //Reporte Estadistico
  const exportarXLSX = async () => {
    let infoToken = await consultarInfoToken();
    if (infoToken.idUsuario === 0 || !infoToken.idUsuario) {
      navigate("/", { replace: true });
    }
    try {
      const ws = utils.json_to_sheet(dataReporteXlsx);
      const wb = utils.book_new();

      utils.book_append_sheet(wb, ws, "Reporte estadistico");

      const configCols = dataReporteXlsx.map((estadistica) => {
        return { wch: 30 };
      });

      ws["!cols"] = configCols;

      writeFileXLSX(wb, "ReporteEstadistico.xlsx");
    } catch (error) {
      alert("No se puede generar el reporte");
      return false;
    }
  };

  const listarEstadisticas = async (page = 1, clear = false) => {
    let infoToken = await consultarInfoToken();
    if (infoToken.idUsuario === 0 || !infoToken.idUsuario) {
      navigate("/", { replace: true });
    }
    setFiltrosReportes((prev) => {
      return { ...prev, page: page };
    });

    setLoad(true);

    let jsonFiltros = { ...filtrosReportes };
    if (clear) {
      jsonFiltros = { ...initialStateFiltros };
    }

    try {
      filtrosReportes.page = page;
      const response = await getDatos(
        "atributos/estadisticas/reporte",
        jsonFiltros
      );

      let { busqueda, infoReporte } = response;
      setDataReporte({ ...dataReporte, ...busqueda });

      setLoad(false);

      setDataReporteXlsx(
        infoReporte.map((estadistica) => {
          let jsonTemp = {};
          Object.keys(estadistica).map(
            (key) => (jsonTemp[key.toUpperCase()] = estadistica[key])
          );
          return jsonTemp;
        })
      );
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    window.scroll(0, 0);
    restablecerEstilos();
    listarCombosReporte();
  }, []);

  function changePage(page) {
    setCurrentPage(page);
    listarEstadisticas(page);
  }

  return (
    <>
      <Load visible={load} />
      <Container className="content-estadisticas" fluid={true}>
        <div
          className="img-logo-datosabiertos"
          style={{
            backgroundImage: `url("${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Banner/${idComponente}/${imagen}")`,
          }}
        >
          {permissions.superAdmin ? (
            <div className="edit-banner">
              <UploadFileIcon
                icon={<MdOutlineModeEdit color="#fff" size={"20px"} />}
                idComponente={idComponente}
              />
            </div>
          ) : null}
          <div className="content-degradado">
            <div className="content-contendido-img-banner">
              <label className="lblitulo-txt-imgbanner">Estadísticas</label>
              <p>
                <label className="lbdescripcion-txt-imgbanner">
                  {descripcion}
                </label>
              </p>
            </div>
          </div>
        </div>
        <label className="color-borde-img-banner"></label>
        <Migas ruta="Estadísticas" />
        <Tabs defaultActiveKey="reporte" id="tabsEstadisticas" className="mb-3">
          <Tab eventKey="reporte" title="Calificaciones">
            <Container>
              <Row>
                <Col md={4} lg={4} sm={4} xs={4}>
                  <DatePickerGeo
                    stateFather={filtrosReportes.dateRange}
                    onChangeDatePicker={onChangeFiltros}
                  />
                </Col>
                <Col md={4} lg={4} sm={4} xs={4}>
                  <Combo
                    value={filtrosReportes.tipo}
                    nameCombo={"tipo"}
                    onChangeCombo={({ target }) =>
                      onChangeFiltros(target, "combo")
                    }
                    dataOption={combosFiltros.resultTipoRecurso.map((tipo) => {
                      return {
                        id_combo: tipo.id_tipo,
                        nombreOption: tipo.nombre_tipo,
                      };
                    })}
                    titleLabel={"Tipo de recurso"}
                  />
                </Col>

                <Col md={4} lg={4} sm={4} xs={4}>
                  <div id="divCheckEstado" className="mb-3">
                    <label class="label-forms-admin form-label">Estado</label>
                    <div className="container-radio">
                      {combosFiltros.resultTipoEstado.map((estado) => (
                        <label
                          key={"estaod" + estado.id_estado}
                          className={"form-label"}
                        >
                          <input
                            onChange={({ target }) =>
                              onChangeFiltros(target, "radio")
                            }
                            type="radio"
                            id="estado"
                            name="estado"
                            value={estado.id_estado}
                            checked={
                              String(estado.id_estado) ===
                              filtrosReportes.estado
                            }
                          />
                          {estado.nombre_estado}
                        </label>
                      ))}
                    </div>
                  </div>
                </Col>

                <Col xs={12}>
                  <div className="container-buttons-estadisticas">
                    <button
                      style={{ marginRight: "auto" }}
                      className="btn-principal btn-estadisticas mb-3"
                      onClick={(e) => exportarXLSX()}
                    >
                      Descargar estadística
                    </button>
                    <button
                      className="btn-aux btn-estadisticas mb-3"
                      onClick={(e) => limpiarFiltros()}
                    >
                      Limpiar
                    </button>
                    <button
                      className="btn-principal btn-estadisticas mb-3"
                      onClick={(e) => listarEstadisticas()}
                    >
                      Buscar
                    </button>
                  </div>
                </Col>
              </Row>
              <div
                className="flex-table_geomedellin mt-2"
                id="tablaEstadisticas"
              >
                <table className="content-table_geomedellin">
                  <thead>
                    <tr>
                      <th>
                        <font>Tipo recurso</font>
                      </th>
                      <th>
                        <font>Nombre recurso</font>
                      </th>
                      <th>
                        <font>Temática</font>
                      </th>
                      <th>
                        <font>Activo</font>
                      </th>
                      <th>
                        <font>Calificación</font>
                      </th>
                      <th>
                        <font>Fecha</font>
                      </th>
                      <th>
                        <font>Nombre</font>
                      </th>
                      <th>
                        <font>Correo</font>
                      </th>
                      <th>
                        <font>Uso</font>
                      </th>
                      <th>
                        <font>Descripción Calificación</font>
                      </th>
                    </tr>
                  </thead>
                  <TableReporteEstadistica data={dataReporte.data ?? []} />
                </table>
              </div>
              {dataReporte.meta.total > 0 ? (
                <Row>
                  <Col sm={12}>
                    <Pagination
                      totalRows={dataReporte.meta.total}
                      rowPerPage={dataReporte.meta.per_page}
                      currentPage={currentPage}
                      setCurrentPage={changePage}
                      idComponente={idComponente}
                      className={"mt-2 px-2"}
                    />
                  </Col>
                </Row>
              ) : (
                <></>
              )}
            </Container>
          </Tab>
          <Tab eventKey="estadisticasDatosAbiertos" title="Datos abiertos">
            <EstadisticasDatosAbiertos
              combosFiltros={combosFiltros}
              idComponente={idComponente}
              setLoad={setLoad}
              navigate={navigate}
            ></EstadisticasDatosAbiertos>
          </Tab>
          <Tab eventKey="tableros" title="Tableros de Control">
            <Tableros resultTipoTablero={combosFiltros.resultTipoTablero} />
          </Tab>
        </Tabs>
      </Container>
      <PiePagina fluid={true} />
    </>
  );
}
